
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '../../authorization.service';
import { KeyValue } from '../../key-value';



export interface IHash {
  [details: string] : string;
}

@Component({
  selector: 'help-overview-content',
  templateUrl: 'help-overview.component.html',
  styleUrls: ['help-overview.component.css']
})

export class HelpOverviewComponent implements OnInit{
  currentTab = "guide";
  helpItem = "other";
  searchText='';

  urls: IHash | undefined;
  role = '';
  

  constructor(private router: Router, public authService: AuthorizationService, private KeyValueService: KeyValue,){
    this.role = authService.getCRole();
  }

  ngOnInit(): void {
    console.log('dnfnfnf');
    this.KeyValueService.helpUrl$.subscribe((url1) => {
      console.log(' subscribe to helpUrl$ '+url1);
      this.helpItem = url1;
    });

  }

  setTab1(ss){
    console.log('ss');    
    console.log(ss);
    this.currentTab = ss;
  }
}